import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { TextMessageBuilderForm } from '../interfaces';
import { MatInputModule } from '@angular/material/input';
import { DynamicComponentSelectorModule } from '@galaxy/templates';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SmsTextLimitToken } from '../../token';
import { BehaviorSubject } from 'rxjs';

const regex = new RegExp(`{{\\s*([^}]+)\\s*}}`, 'g');

const FALLBACK_TEXT_LIMIT = 95;

@Component({
  selector: 'sms-builder-form',
  templateUrl: 'text-message-builder-form.component.html',
  styleUrls: ['./text-message-builder-form.component.scss'],
  imports: [
    CommonModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    DynamicComponentSelectorModule,
    TranslateModule,
  ],
})
export class TextMessageBuilderFormComponent implements OnInit {
  smsForm = new FormGroup({
    name: new FormControl(''),
    message: new FormControl(''),
  });
  calculatedTextLength$$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  @ViewChild('smsText') smsText?: ElementRef<HTMLTextAreaElement>;

  @Input()
  set setInitialInputText(inputText: TextMessageBuilderForm) {
    this.smsForm.patchValue(inputText);
    this.calculatedTextLength$$.next(inputText?.message?.replaceAll(regex, '').length ?? 0);
  }

  @Input() allowDynamic: boolean;
  @Input() setTextLimit: boolean;

  @Output() template: EventEmitter<TextMessageBuilderForm> = new EventEmitter();
  @Output() valid: EventEmitter<boolean> = new EventEmitter();

  constructor(@Inject(SmsTextLimitToken) @Optional() public readonly textLimit: number) {
    if (!textLimit) this.textLimit = FALLBACK_TEXT_LIMIT;
  }

  ngOnInit() {
    this.smsForm.valueChanges.subscribe((value) => {
      this.calculatedTextLength$$.next(value?.message?.replaceAll(regex, '').length ?? 0);
      this.template.emit(value as TextMessageBuilderForm);
    });
    this.smsForm.statusChanges.subscribe((status) => {
      this.valid.emit(status === 'VALID');
    });
  }

  emitNewTemplateValue(value: string) {
    this.smsForm.get('message').setValue(value);
    this.smsForm.updateValueAndValidity();
  }
}
